import type { MachineDto } from '../../services/machinesApi';

interface Props {
  machines: MachineDto[] | undefined;
  selectedMachineId: string | null;
  onMachineChange: (id: string) => void;
  from: string;
  to: string;
  onFromChange: (s: string) => void;
  onToChange: (s: string) => void;
  loading?: boolean;
}

const MachineFilters = ({
  machines,
  selectedMachineId,
  onMachineChange,
  from,
  to,
  onFromChange,
  onToChange,
  loading,
}: Props) => (
  <>
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <span className="text-slate-500">Machine</span>
      <select
        value={selectedMachineId ?? ''}
        onChange={(e) => onMachineChange(e.target.value)}
        className="rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-sm focus:border-tfs-primary focus:outline-none focus:ring-1 focus:ring-tfs-primary"
        disabled={loading}
      >
        {machines?.map((m) => (
          <option key={m.uid} value={m.id ?? ''}>
            {m.id} ({m.machineType})
          </option>
        ))}
      </select>
    </label>
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <span className="text-slate-500">From</span>
      <input
        type="date"
        value={from}
        onChange={(e) => onFromChange(e.target.value)}
        className="rounded-md border border-slate-300 px-2.5 py-1.5 text-sm"
      />
    </label>
    <label className="flex items-center gap-2 text-sm text-slate-600">
      <span className="text-slate-500">To</span>
      <input
        type="date"
        value={to}
        onChange={(e) => onToChange(e.target.value)}
        className="rounded-md border border-slate-300 px-2.5 py-1.5 text-sm"
      />
    </label>
  </>
);

export default MachineFilters;
